export const DKK_CONVERSION_RATE = 7.5;

export const PRICING_CONFIG = {
  setup: {
    priceEur: 999,
  },
  platform: {
    priceEur: 129,
  },
  energy: {
    priceEur: 99,
  },
  users: {
    priceEur: 49,
    minQty: 1,
  },
  companies: {
    priceEur: 79,
    minQty: 1,
  },
  countries: {
    priceEur: 129,
    minQty: 1,
  },
  locations: {
    priceEur: 129,
    minQty: 1,
  },
};
